import React from 'react'
import Fragment from '../common/fragment'


function FragmentCY(props) {
  return (
    <Fragment pos="yyy" {...props}>
      <p>
Abandonar la ciudad no es posible. ¿Dónde iríamos? Imaginen otros lugares.
Otros Cristos y otras Abejas. Otras negruras. Cada quien encontrará su encierro y su
ceguera. El pulso y el ritmo del corazón. El aire, simulacros de lo abierto. No nos
podemos marchar: ¿dónde iríamos?, ¿a paraísos sin máquinas ni humo?, ¿a valles
sin ovejas ni balidos?, ¿a un lugar sin grietas y sin misterios? Cada quien encontrará
su encierro y el encanto de los ríos, la turbiedad del aire. La ciudad es una imagen
interior, un sueño parsimonioso, una agonía. ¿Dónde iríamos?, ¿a las colmenas
abandonadas de las abejas?, ¿al fuego de las chimeneas?, ¿a las orillas del río?
      </p>
    </Fragment>
  )
}


export default FragmentCY
